// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { mergeWithCss, xClassNames } from "@awc/XDL/Utilities";
import Clickable, { ClickablePresentationProps, ClickableProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useState } from "react";

export interface HeaderClickableItemProps {
    isOpen?: boolean;
    showIcon?: boolean;
    extendedStyles?: HeaderClickableStyles;
}

export type HeaderClickableProps = HeaderClickableItemProps & ClickableProps;

type Props = HeaderClickableProps;

export interface HeaderClickableStyles {
    clickable?: ClickablePresentationProps;
    icon?: IconPresentationProps;
    title?: TypographyPresentationProps;
    arrow?: IconPresentationProps;
    openColor?: TypographyProps["color"];
}

export const headerClickableStyles: HeaderClickableStyles = {};

const HeaderClickable: FC<Props> = ({ isOpen, children, showIcon = true, extendedStyles, ...otherProps }) => {
    const [styles] = useState(() => mergeWithCss(headerClickableStyles, extendedStyles));
    const className = xClassNames.append([isOpen && "opened"], otherProps.className);

    return (
        <Clickable {...styles.clickable} {...otherProps} className={className}>
            {showIcon && styles.icon?.src && (
                <Icon
                    {...styles.icon}
                    color={isOpen ? styles.openColor : styles.icon.color}
                    className="clickable-icon"
                />
            )}
            <Typography {...styles.title} color={isOpen ? styles.openColor : styles.title?.color}>
                {children}
            </Typography>
        </Clickable>
    );
};

export default HeaderClickable;
